import { ISelectOption } from "components/common/CustomSelect";

const notificationSelect: ISelectOption[] = [
    { value: 'quote', label: '견적', labelEn: 'quote' },
    { value: 'order', label: '진행', labelEn: 'order' },
];

export { notificationSelect }